import NebPay from 'nebpay.js'
import _ from 'lodash'
import nebulas from 'nebulas'

// 配置2 网络请求地址 mainnet
const httpRequestUrl = 'https://mainnet.nebulas.io';
const payCallBackUrl = 'https://pay.nebulas.io/api/mainnet/pay';

// 配置2 网络请求地址 testnet
// const httpRequestUrl = 'https://testnet.nebulas.io';
// const payCallBackUrl = 'https://pay.nebulas.io/api/pay';

const nebpay = new NebPay();
const neb = new nebulas.Neb();
neb.setRequest(new nebulas.HttpRequest(httpRequestUrl));
const api = neb.api;

const actions = {
  // simulateCall方法封装
  simulateCallNew ({state, commit}, p) {
    let params = p.params || [];
    let dappAddress = state.dappAddress;
    console.log('模拟调用合约BEGIN：', p.funcName)
    return new Promise(function (resolve, reject) {
      nebpay.simulateCall(dappAddress, '0', p.funcName, JSON.stringify(params), {
        goods: p.goods,
        callback: payCallBackUrl,
        listener: function (resp) {
          console.log('模拟调用合约END：', p.funcName, resp)
          if (resp.result) {
            resolve(resp.result)
          } else {
            reject(resp)
          }
        }
      })
    })
  },
  // call方法封装
  callNew ({state, commit, dispatch}, p) {
    let params = p.params || [];
    let dappAddress = state.dappAddress;
    console.log('正式调用合约BEGIN：', p.funcName)
    return new Promise(function (resolve, reject) {
      nebpay.call(dappAddress, '0', p.funcName, JSON.stringify(params), {
        goods: p.goods,
        callback: payCallBackUrl,
        listener: function (resp) {
          console.log('正式调用合约END：', p.funcName, resp)
          if (resp.result) {
            resolve(resp.result)
          } else if (resp.txhash) {
            dispatch('intervalQuery', resp.txhash).then(function (result) {
              resolve(result)
            }, function (error) {
              reject(error)
            })
          } else {
            reject(resp)
          }
        }
      })
    })
  },
  intervalQuery ({dispatch}, txhash) {
    console.log('txhash', txhash)
    return new Promise(function (resolve, reject) {
      api.getTransactionReceipt({hash: txhash}).then(function (receipt) {
        if (_.get(receipt, 'status', '') === 1) {
          // success
          resolve(receipt)
        } else if (_.get(receipt, 'status', '') === 0) {
          // fail
          reject(receipt)
        } else {
          _.delay(function () {
            dispatch('intervalQuery', txhash).then(function (result) {
              resolve(result)
            })
          }, 5000)
        }
      });
    })
  },
  // 初始化基础账户
  initBaseAccount ({dispatch, commit}) {
    var p = new Promise(function (resolve, reject) {
      // 初始化变量
      commit('setAccountsError', null)
      commit('setUser', null)
      commit('setAccounts', null)
      commit('setNebPay', nebpay)

      commit('setAccountsError', '检测浏览器...')
      if (_.get(navigator, 'userAgent', '').toLowerCase().indexOf('chrome') === -1) {
        commit('setAccountsError', '请使用Chrome浏览器')
        return reject(new Error('请使用Chrome浏览器'))
      }

      commit('setAccountsError', '检测网络...')
      if (!navigator.onLine) {
        commit('setAccountsError', '请接入互联网')
        return reject(new Error('请接入互联网'))
      }

      commit('setAccountsError', '检测钱包插件...')
      _.delay(function () {
        if (typeof webExtensionWallet === 'undefined') {
          commit('setAccountsError', '请安装并且登录钱包')
          return reject(new Error('请安装并且登录钱包'))
        }

        commit('setAccountsError', '检测合约地址...')
        dispatch('simulateCallNew', {funcName: 'getUserAddress'}).then(function (result) {
          if (result === 'null') {
            commit('setAccountsError', '请登录钱包')
            return reject(new Error('请登录钱包'))
          } else {
            let account = result.slice(1, -1);
            commit('setAccounts', [account])

            commit('setAccountsError', '加载用户信息...')
            dispatch('simulateCallNew', {funcName: 'getUserInfo'}).then(function (ret) {
              if (ret === 'null') {
                commit('setAccountsError', '请注册老师/学生')
                return resolve()
              } else {
                commit('setAccountsError', null)
                let user = JSON.parse(ret);
                commit('setUser', user)
                return resolve()
              }
            }, function (error) {
              commit('setAccountsError', '请注册老师/学生')
              return reject(error)
            });
          }
        }, function (error) {
          if (error && error.execute_err === 'contract check failed') {
            commit('setAccountsError', '请切换到mainnet')
            return reject(error)
          } else {
            commit('setAccountsError', '请登录钱包')
            return reject(error)
          }
        })
      }, 500)
    })
    return p
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js